import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import confetti from 'canvas-confetti';
import { localStorageConstants } from 'src/consts/local-storage-constants';
import { WEB_ROUTES } from 'src/consts/routes';


@Component({
  selector: 'app-payment-status-form',
  templateUrl: './payment-status-form.component.html',
  styleUrls: ['./payment-status-form.component.scss'],
  standalone: false
})
export class PaymentStatusFormComponent implements OnInit {
  payment_image_url: String = "./assets/images/payment-success.png";

  constructor(private router: Router) {

  }

  ngOnInit() {
    this.launchConfetti();
  }

  launchConfetti() {
    const duration = 5 * 1000; // 5 seconds
    const end = Date.now() + duration;

    (function frame() {
      confetti({
        particleCount: 5,
        angle: 60,
        spread: 55,
        origin: { x: 0 }
      });
      confetti({
        particleCount: 5,
        angle: 120,
        spread: 55,
        origin: { x: 1 }
      });
      if (Date.now() < end) {
        requestAnimationFrame(frame);
      }
    })();
  }

  goToHome() {
    this.router.navigate([WEB_ROUTES.LOGIN]);
    localStorage.removeItem(localStorageConstants.USERDATA);
    localStorage.removeItem(localStorageConstants.COMPANYDATA);
    localStorage.removeItem(localStorageConstants.COMPANYID);
    localStorage.removeItem(localStorageConstants.INVOICE_GIF);
    localStorage.removeItem(localStorageConstants.INVOICE_TOKEN);
  }
}